<app-fixed-editor *ngIf="_element.editorId && fixedEditor && !isSubmitted" [element]="fixedEditor"></app-fixed-editor>
<div *ngIf="!isSubmitted && !immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question--titleBox">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <div *ngIf="_element?.description" class="new-question--hint">{{_element?.description}}</div>
    </div>
    <div class="new-options">
      <div class="new-options new-options__twothird-width">
        <div class="new-options--input-wrap position-relative">
          <app-web-speech [_element]="_element" [answer]="_answer" (textValue)="setValue($event)"></app-web-speech>
          <div class="new-options--count">
            <span>{{1}}-{{_element.wordLimit}} words</span>
          </div>
        </div>
      </div>
    </div>
    <app-exercise-navigation-bar [id]="id" [questionAttempted]="_answer" (onNext)="next()" (onSubmit)="next(true)"
      [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
      [index]='index'>
    </app-exercise-navigation-bar>
  </div>
</div>
<div *ngIf="!isSubmitted && immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question--titleBox">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
    </div>
    <div class="new-options">
      <div class="new-options new-options__twothird-width">
        <div class="new-options--input-wrap position-relative">
          <textarea [class.disabled]="questionChecked" [(ngModel)]="_answer" class="new-options--input large"
            (keyup)="onInput(_answer)" [class.large]="_element.wordLimit>100"
            [class.medium]="_element.wordLimit>50 && _element.wordLimit<=100 " [class.small]="_element.wordLimit<=50"
            cols="3" rows="5" placeholder="Type here"></textarea>
          <div class="new-options--count">
            <span>{{1}}-{{_element.wordLimit}} words</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="_answer && questionChecked &&  _element?.isFeedbackEnabled" class="overall-feedback pb-0">
      <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
    </div>
    <app-exercise-navigation-bar [id]="id" [immediateFeedBackRequired]="true" [questionAttempted]="_answer"
      (onReview)="check()" (onNext)="next()" (onSubmit)="next(true)" [questionChecked]="questionChecked"
      [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
      [index]='index'
      >
    </app-exercise-navigation-bar>
  </div>
</div>
<div *ngIf="isSubmitted" [class.new-options--not-answered]="!_answer" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container">
    <div class="new-question--titleBox"
      [class.score-applied]="_element?.isScoring &&  _answer && points  && isResultPublished">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <!-- <span *ngIf="!isPractice && _element?.isScoring &&  _answer && points  && isResultPublished && !isTouchstone"
        class="answer-point">Points:
        {{(points?points.point:0 ) | number:'1.0-2'}} out of
        {{(points?points.total:0 ) | number:'1.0-2'}}</span> -->
    </div>
    <div class="new-options">
      <div class="new-options new-options__twothird-width">
        <div class="new-options--input-wrap position-relative">
          <textarea [class.disabled]="isSubmitted" [(ngModel)]="_answer" class="new-options--input large"
            [class.large]="_element.wordLimit>100" [class.medium]="_element.wordLimit>50 && _element.wordLimit<=100 "
            [class.small]="_element.wordLimit<=50" cols="3" rows="5" placeholder="Type here"></textarea>
        </div>
      </div>
    </div>
    <div *ngIf="taFeedback?.feedback && !taFeedback?.rowsFeedback?.length" class="overall-feedback">
      <p [froalaView]="taFeedback.feedback" class="overall-feedback__desc"></p>
    </div>
    <div *ngIf="!taFeedback?.feedback && !taFeedback?.rowsFeedback?.length && _element?.isFeedbackEnabled"
      class="overall-feedback">
      <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
    </div>
  </div>
   <!-- thrive -->
   <ng-container *ngIf="questionBlos && questionBlos.length">     
    <h5 class="question__thrive">Thrive Skills:</h5>
    <div class="question__thrive-list">
      <ul>
        <ng-container *ngFor="let blo of questionBlos">
          <li [innerHTML]="blo.shortStatement"></li>
        </ng-container>
      </ul>
    </div>
  </ng-container>
  <!-- <app-like-dislike [id]="id"
    *ngIf="!taFeedback?.feedback && !taFeedback?.rowsFeedback?.length && _element?.isFeedbackEnabled"
    [userFeedback]="userFeedback" [_element]="_element" (reportFeedback)="_reportFeedback($event)"
    (likeDislike)="_likeDislike($event)">
  </app-like-dislike> -->
</div>
<ng-container *ngIf="isSubmitted">
  <div class="new-question__container new-question new-question-top-align mx-auto">
    <app-rowsfeedback [taFeedback]="taFeedback" *ngIf="taFeedback?.rowsFeedback?.length>0"></app-rowsfeedback>
  </div>
</ng-container>
